// extracted by mini-css-extract-plugin
export default {"inputFields":"inputFields_inputFields__2H6yI","label":"inputFields_label__62m5e"};